
import { mapActions } from 'vuex';

import { AUTH_LOGIN } from '@/components/auth/helpers/auth-component-names';
import SvgContainer from '@/components/core/svg-container/svg-container';
import CssCustomizer from '@/components/static/css-customizer/css-customizer';
import { QUIZ_PRODUCT_TYPES } from '@/modules/product/domain/product';

export default {
  name: 'LayoutPayment',
  components: {
    SvgContainer,
    CssCustomizer,
  },
  head() {
    const pilatesStyles = {
      ':root': {
        '--c-primary': '#007BBD !important',
        '--c-primary-dark': '#007BBD !important',
        '--c-primary-light': '#3B99CC !important',
        '--border-radius': '6.25rem !important',
        '--c-disabled': '#A4CDE2 !important',
        '--c-gray-200': '#E9F0F4 !important',
      },
      '.balance-text': {
        'text-transform': 'initial !important',
      },
    };

    const traditionalStyles = {
      ':root': {
        '--c-primary': '#B82F60 !important',
        '--c-primary-dark': '#B82F60 !important',
        '--border-radius': '6.25rem !important',
      },
      '.balance-text': {
        'text-transform': 'initial !important',
      },
      '.discount-timer-payment': {
        '--c-timer-separator': '#D691AA !important',
      },
    };

    const ketoStyles = {
      ':root': {
        '--c-primary': '#3B7841 !important',
        '--c-primary-dark': '#3B7841 !important',
        '--c-primary-light': '#3B99CC !important',
        '--c-primary-light-1': '#4D8A53 !important',
        '--c-disabled': '#ADC6AF !important',
        '--border-radius': '6.25rem !important',
      },
      '.discount-timer': {
        'background-color': '#007BBD !important',
      },
      '.balance-text': {
        'text-transform': 'initial !important',
      },
    };

    const yogaStyles = {
      ':root': {
        '--c-primary': 'var(--yoga-primary) !important',
        '--c-primary-dark': 'var(--yoga-primary-dark) !important',
        '--c-primary-light': 'var(--yoga-primary-light) !important',
        '--border-radius': '6.25rem !important',
      },
      '.balance-text': {
        'text-transform': 'initial !important',
      },
      '.main-header': {
        '--c-background-color': 'var(--yoga-primary) !important',
      },
      '.discount-timer': {
        'background-color': '#5795C6 !important',
      },
    };

    const somaticYoga = {
      ':root': {
        '--c-primary': 'var(--somatic-yoga-primary) !important',
        '--c-primary-dark': 'var(--somatic-yoga-primary-dark) !important',
        '--c-primary-light': 'var(--somatic-yoga-primary-light) !important',
        '--border-radius': '6.25rem !important',
      },
      '.balance-text': {
        'text-transform': 'initial !important',
      },
      '.discount-timer': {
        'background-color': '#5795C6 !important',
      },
    };

    const fitnessWalkingStyles = {
      ':root': {
        '--c-primary': 'var(--fitness-walking-primary) !important',
        '--c-primary-dark': 'var(--fitness-walking-primary-dark) !important',
        '--c-primary-light': 'var(--fitness-walking-primary-light) !important',
        '--border-radius': '6.25rem !important',
        '--c-disabled': 'var(--fitness-walking-primary-light) !important',
      },
      '.balance-text': { 'text-transform': 'initial !important' },
      '.button': { 'box-shadow': 'none !important' },
    };

    const nutritionFastingStyles = {
      ':root': {
        '--c-primary': 'var(--nutrition-fasting-primary) !important',
        '--c-primary-dark': 'var(--nutrition-fasting-primary-dark) !important',
        '--c-primary-light': 'var(--nutrition-fasting-primary-light) !important',
        '--border-radius': '6.25rem !important',
        '--c-disabled': 'var(--nutrition-fasting-primary-light) !important',
      },
      '.balance-text': { 'text-transform': 'initial !important' },
      '.button': { 'box-shadow': 'none !important' },
    };

    const quizVariantStyles = {
      [QUIZ_PRODUCT_TYPES.nutritionMenopause]: traditionalStyles,
      [QUIZ_PRODUCT_TYPES.nutritionKeto]: ketoStyles,
      [QUIZ_PRODUCT_TYPES.fitnessPilates]: pilatesStyles,
      [QUIZ_PRODUCT_TYPES.nutritionGeneric]: traditionalStyles,
      [QUIZ_PRODUCT_TYPES.fitnessYoga]: yogaStyles,
      [QUIZ_PRODUCT_TYPES.fitnessYogaMenopause]: yogaStyles,
      [QUIZ_PRODUCT_TYPES.fitnessSomaticYoga]: somaticYoga,
      [QUIZ_PRODUCT_TYPES.fitnessSomaticExercises]: somaticYoga,
      [QUIZ_PRODUCT_TYPES.fitnessWalking]: fitnessWalkingStyles,
      [QUIZ_PRODUCT_TYPES.nutritionFasting]: nutritionFastingStyles,
    };

    const styles = Object.entries(quizVariantStyles[this.getProductType] || traditionalStyles)
      .map(([key, value]) =>
        typeof value === 'object'
          ? `${key} { ${Object.entries(value)
              .map(([prop, val]) => `${prop}: ${val};`)
              .join(' ')} }`
          : `${key}: ${value}`,
      )
      .join(' ');

    return {
      bodyAttrs: {
        class: this.$exp.$classes.join(' '),
      },
      htmlAttrs: {
        lang: this.$i18n.locale.split('-')[0] || 'en',
      },
      style: [
        {
          cssText: styles,
        },
      ],
    };
  },
  watch: {
    $route() {
      if (process.client) {
        if (window) {
          window.scrollTo({ top: 0 });
        }
      }

      this.setAuthComponentName(AUTH_LOGIN);
    },
  },
  mounted() {
    if (window && window.balanceText && typeof window.balanceText === 'function') {
      window.balanceText('.balance-text');
    }

    this.queryHandler();
  },
  methods: {
    ...mapActions('auth', ['setAuthComponentName']),
  },
};
